import "./NewProjectJourneyPage.css";

import { AssetManagerTemplate, DeveloperTemplate } from "../../../../templates";
import { Column, Row, UserHeader } from "../../../../widget";
import { NewProjectJourney } from "./NewProjectJourney";
import { NewProjectJourneyProvider } from "./NewProjectJourneyProvider";
import { useNewProjectJourneyPage } from "./useNewProjectJourneyPage";

const NewProjectJourneyPage = (): JSX.Element => {
  const { pageTitle, isSeed, journeyKey, handleComplete } = useNewProjectJourneyPage();

  const content = (
    <div className="NewProjectJourneyPage">
      {/* Seed pages carry no user header; the developer and development-manager hubs do. */}
      {!isSeed && (
        <Row spacingV="ml">
          <Column span={12}>
            <UserHeader />
          </Column>
        </Row>
      )}

      <NewProjectJourneyProvider key={journeyKey} onComplete={handleComplete}>
        <NewProjectJourney title={pageTitle} />
      </NewProjectJourneyProvider>
    </div>
  );

  return isSeed ? (
    <AssetManagerTemplate activeElement="Projects">{content}</AssetManagerTemplate>
  ) : (
    <DeveloperTemplate activeElement="Projects">{content}</DeveloperTemplate>
  );
};

export default NewProjectJourneyPage;
